import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import "./TestimonialsPage.css";
import DashboardLayout from '../Dashboard/layout';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Form } from 'react-bootstrap';
import countryList from './countriescities.json';

const AddTestimonials = () => {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    country: '',
    bio: '',
    status: '',
    image: null,
    imagePreview: null // Image preview ke liye state
  });

  const navigate = useNavigate();
  const [countries] = useState(countryList);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        image: file,
        imagePreview: URL.createObjectURL(file) // Image preview ke liye URL set karna
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name) errors.name = 'Name is required';
    if (!formData.age) errors.age = 'Age is required';
    if (!formData.country) errors.country = 'Country is required';
    if (!formData.bio) errors.bio = 'Bio is required';
    if (!formData.status) errors.status = 'Status is required';
    if (!formData.image) errors.image = 'Image is required';
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      Swal.fire('Error', 'Please fill in all required fields', 'error');
      return;
    }

    try {
      const form = new FormData();
      form.append('name', formData.name);
      form.append('age', formData.age);
      form.append('country', formData.country);
      form.append('bio', formData.bio);
      form.append('status', formData.status);
      form.append('image', formData.image);
      
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/testimonials`,
        form,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (res.data.status === 0) {
        Swal.fire('Error', 'Testimonial already exists!', 'error');
      } else {
        Swal.fire('Success', 'New testimonial added successfully!', 'success');
        navigate("/testimonials");
      }
    } catch (error) {
      console.error('Error submitting data', error);
      Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
    }
  };

  return (
    <DashboardLayout>
      <section className="MainDivSec">
        <Headings headspan="Add" hedtext=" Testimonials" />
        <div className="AdduserFormDiv">
          <Form onSubmit={handleSubmit}>
            <div className="FormGroupDiv">
              <label>Name:</label>
              <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
            </div>

            <div className="FormGroupDiv">
              <label>Age:</label>
              <input type="number" name="age" value={formData.age} onChange={handleInputChange} required />
            </div>

            <div className="FormGroupDiv">
              <label>Country:</label>
              <select name="country" value={formData.country} onChange={handleInputChange} required>
                <option value="">Select Country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country.name}>{country.name}</option>
                ))}
              </select>
            </div>

            <div className="FormGroupDiv">
              <label>Bio:</label>
              <textarea name="bio" value={formData.bio} onChange={handleInputChange} required></textarea>
            </div>

            <div className="FormGroupDiv">
              <label>Status:</label>
              <select name="status" value={formData.status} onChange={handleInputChange} required>
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <div className="FormGroupDiv">
              <label>Upload Image:</label>
              <input type="file" name="image" accept="image/*" onChange={handleImageChange} required />
              {formData.imagePreview && (
                <div className="image-preview">
                  <img src={formData.imagePreview} alt="Preview" style={{ width: "150px", height: "150px", marginTop: "10px", borderRadius: "8px" }} />
                </div>
              )}
            </div>

            <div className="SubMit">
              <button type="submit">Add Testimonial</button>
            </div>
          </Form>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default AddTestimonials;
